export const GET_COOKIES = 'GET/COOKIES'
export const SET_COOKIES = 'SET/COOKIES'
export const REMOVE_COOKIES = 'REMOVE/COOKIES'
export const SHOW_COOKIE_NOTIFICATION ='SHOW/COOKIE_NOTIFICATION'
export const HIDE_COOKIE_NOTIFICATION = 'HIDE/COOKIE_NOTIFICATION'